import { keys, map, mergeDeepRight, reduce } from 'ramda';

import {
  LOAD_DOCUMENTS_BY_IDS_SUCCESS,
  LOAD_DOCUMENT_BY_ID_SUCCESS,
  LOAD_DOCUMENT_BY_UID_SUCCESS,
  LOAD_PAGINATED_QUERY_SUCCESS,
  LOAD_SINGLE_TYPE_DOC_SUCCESS,
} from '../actions/prismic';
import { Document } from '../types/document';

export const initialState: EntitiesState = {};

const processUidsToIdMap = (obj: Record<string, any>): Record<string, string> =>
  reduce(
    (acc, id: string) => ({ ...acc, [obj?.[id]?.uid]: id }),
    {},
    keys(obj)
  );

export const entities = (
  state: EntitiesState = initialState,
  action: Record<string, any>
): EntitiesState => {
  switch (action.type) {
    case LOAD_DOCUMENT_BY_ID_SUCCESS:
    case LOAD_DOCUMENT_BY_UID_SUCCESS:
    case LOAD_SINGLE_TYPE_DOC_SUCCESS:
    case LOAD_DOCUMENTS_BY_IDS_SUCCESS:
    case LOAD_PAGINATED_QUERY_SUCCESS: {
      const entities = action.payload?.entities || {};
      return {
        ...state,
        [action.lang]: mergeDeepRight(state[action.lang], {
          ...entities,
          uids: mergeDeepRight(
            state[action.lang]?.uids || {},
            map(processUidsToIdMap, entities)
          ),
        }),
      };
    }
    default:
      return state;
  }
};

export type EntitiesState = Record<
  string,
  {
    uids: Record<string, Record<string, string>>;
    [x: string]: Record<string, Document> | Record<string, Record<string, any>>;
  }
>;
